import { PageNotFound } from '@shared/components';

export default function NotFoundPage() {
  return <PageNotFound fullscreen />;
}
